/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Instructions_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add instructions to customize how the AI responds in this project." |
*
* @param {Project_Instructions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_instructions_description = /** @type {((inputs?: Project_Instructions_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Instructions_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge Anweisungen hinzu, um zu steuern, wie die KI in diesem Projekt antwortet.")
	return /** @type {LocalizedString} */ ("Add instructions to customize how the AI responds in this project.")
});